import { countDecimals } from './countDecimals';
/**
 * Función de uso interno.
 * Busca el numero maximo de decimales entre una lista de numeros
 * Sirve para convertir los float en int para los calculos javascript
 *
 * @param {array<float>} args: la lista de numeros
 *
 * @return {int} el numero de decimales maximo encontrado en la lista
 */

export function getMultiplicator(args) {
  const decimals = Math.max(...args.map(countDecimals));
  const multiplicator = decimals ? Math.pow(10, decimals) : 1;
  return multiplicator;
}
